import { useState } from 'react'
import { useAsyncEffect } from 'utils'
import { MediaSprite } from '../../../types'
import { mediaSpriteFromSource } from '../../../utils/media'

export function useSprite(source: File | string, fps: number) {
    const [state, setState] = useState<MediaSprite | null>(null)

    useAsyncEffect(async () => {
        if (!source) return

        const sprite = await mediaSpriteFromSource(source, undefined, fps)

        if (!sprite) {
            throw `unable to generate sprite for ${source}`
        }

        setState(sprite)
    }, [fps, source])

    return state
}
